var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 65,
    viewBox: "0 0 73 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8.80893,
    y: -8.66061,
    width: 81.9984,
    height: 68.332
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.56px)",
      clipPath: "url(#bgblur_0_8767_3004_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 9.11093,
    x: 0.302002,
    y: 0.450317,
    width: 63.7765,
    height: 50.1101,
    rx: 13.6664,
    fill: "url(#paint0_linear_8767_3004)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14.5,
    width: 63.5,
    height: 49.5,
    rx: 12.5,
    fill: "url(#paint1_linear_8767_3004)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7897 44.9838C60.4111 44.3107 59.5277 44.0583 58.8125 44.479L54.0169 47.2554L52.797 47.9705V54.6171L53.9328 55.2901C53.9748 55.2901 53.9748 55.3322 54.0169 55.3322L58.7284 58.0665C58.9387 58.2348 59.2332 58.3189 59.5277 58.3189C60.3269 58.3189 60.9579 57.6879 60.9579 56.8887V51.2517L61 45.6989C61 45.4465 60.9579 45.1941 60.7897 44.9838Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7732 42.8384C36.5171 42.8384 39.5459 39.8095 39.5459 36.0656C39.5459 32.3217 36.5171 29.2928 32.7732 29.2928C29.0292 29.2928 26.0004 32.3217 26.0004 36.0656C25.9584 39.8095 29.0292 42.8384 32.7732 42.8384ZM32.7732 33.2892C34.3297 33.2892 35.5496 34.5512 35.5496 36.0656C35.5496 37.6221 34.2876 38.842 32.7732 38.842C31.2588 38.842 29.9968 37.58 29.9968 36.0656C29.9547 34.5091 31.2167 33.2892 32.7732 33.2892Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9364 43.217C48.8427 43.7638 47.6228 44.1004 46.3187 44.1004C44.7202 44.1004 43.2057 43.6376 41.9437 42.7963H37.1481C35.8861 43.6376 34.3717 44.1004 32.7732 44.1004C31.4691 44.1004 30.2492 43.8059 29.1554 43.217C28.1879 43.7638 27.5148 44.8576 27.5148 46.0354V56.2997C27.5148 58.1927 29.0713 59.7071 30.9222 59.7071H48.2117C50.1047 59.7071 51.6191 58.1507 51.6191 56.2997V46.0354C51.577 44.8576 50.904 43.7638 49.9364 43.217Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3187 42.8384C50.0626 42.8384 53.0914 39.8095 53.0914 36.0656C53.0914 32.3217 50.0626 29.2928 46.3187 29.2928C42.5747 29.2928 39.5459 32.3217 39.5459 36.0656C39.5459 39.8095 42.5747 42.8384 46.3187 42.8384ZM46.3187 33.2892C47.8752 33.2892 49.0951 34.5512 49.0951 36.0656C49.0951 37.6221 47.8331 38.842 46.3187 38.842C44.8043 38.842 43.5423 37.58 43.5423 36.0656C43.5423 34.5091 44.7622 33.2892 46.3187 33.2892Z",
    fill: "white",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_8767_3004_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(8.80893 8.66061)",
    x: 0.302002,
    y: 0.450317,
    width: 63.7765,
    height: 50.1101,
    rx: 13.6664
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8767_3004",
    x1: 18.6991,
    y1: 11.4119,
    x2: 69.2226,
    y2: 33.8809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F4690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8767_3004",
    x1: 40.75,
    y1: 14,
    x2: 40.75,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUploadIcon);
export default __webpack_public_path__ + "static/media/video-upload-icon.460ee9aef06e1c154ccdeae251b9b23a.svg";
export { ForwardRef as ReactComponent };